import axios from "axios";
import { emit, keyFromPath } from "./refreshBus";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BASE}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// iter43: Marka/Kategori/Koleksiyon/Birim/Özellik CRUD sonrası tüm açık filtre panellerine
// canlı invalidation event'i yolla → dropdown'lar anında yenilensin.
const _FILTER_META_PATHS = /\/(brands|categories|collections|units|attributes)(\/|\?|$)/;
api.interceptors.response.use((response) => {
  try {
    const m = String(response.config?.method || "").toLowerCase();
    const url = response.config?.url || "";
    if (["post", "put", "patch", "delete"].includes(m)) {
      if (_FILTER_META_PATHS.test(url) && typeof window !== "undefined") {
        window.dispatchEvent(new Event("filter-options-invalidate"));
      }
      // iter141 — Global refresh bus emit
      const key = keyFromPath(url);
      if (key) emit(key);
    }
  } catch {}
  return response;
});

export const errText = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Bir hata oluştu";
};
